import React from "react";
import PolicyPage, { POLICY_ADDRESS, PolicyEmail } from "./PolicyPage";

function Returns() {
  return (
    <PolicyPage
      title="Return and refund policy"
      intro="This policy explains the standard return process. It does not restrict mandatory cancellation, refund, legal-guarantee, or defective-goods rights in your location."
    >
      <h2>Start a return</h2>
      <p>
        Before sending an item, email
        <PolicyEmail subject="Return request" /> with your order number, the
        item, and the reason for the request. If there is damage, a defect, or a
        packing error, include clear photos. Wait for return instructions so
        the parcel can be identified and sent to the correct location.
      </p>

      <h2>Standard return window</h2>
      <p>
        Unless a longer period was stated at purchase or is required by law,
        contact us within 14 days after delivery. A standard change-of-mind
        return should be unused, unmarked, complete, and in its original
        packaging, with proof of purchase. Reasonable handling needed to inspect
        an item does not remove a right where applicable law says otherwise.
      </p>

      <h2>Cancellation rights in some regions</h2>
      <p>
        Consumers in the European Economic Area, United Kingdom, and certain
        other locations may have a statutory cooling-off period for online
        purchases, commonly 14 days after delivery, with specified exceptions.
        Where that right applies, a clear email sent before the deadline is
        sufficient notice. You must then return the goods within the legally
        required period. Mandatory local rules determine return costs,
        deductions for diminished value, and the refund deadline.
      </p>

      <h2>Non-returnable items</h2>
      <p>To the extent permitted by law, change-of-mind returns may be unavailable for:</p>
      <ul>
        <li>personalized, made-to-order, or clearly customized products;</li>
        <li>sealed hygiene-sensitive goods after the seal is broken;</li>
        <li>items marked final sale before purchase;</li>
        <li>digital content already supplied with the required consent; or</li>
        <li>goods damaged through misuse, neglect, unauthorized repair, or ordinary wear after delivery.</li>
      </ul>
      <p>
        An exception does not remove rights concerning an item that was
        defective, incorrectly described, unsafe, or supplied in error.
      </p>

      <h2>Defective, damaged, or incorrect items</h2>
      <p>
        Notify us promptly. After review, the available remedy may be repair,
        replacement, price reduction, or refund, depending on the facts and
        applicable law. We will provide or reimburse reasonable return shipping
        when the return results from our error or when the law requires it.
      </p>

      <h2>Return shipping</h2>
      <p>
        Return instructions will state who is responsible for postage. For an
        eligible change-of-mind return, the customer normally pays return
        shipping unless we agreed otherwise or local law requires us to pay.
        Use suitable protective packaging and, where reasonably available, a
        trackable service. We are not responsible for a return lost before it is
        delivered to the instructed address, except where we supplied the
        carrier or label and the law assigns that risk to us.
      </p>

      <h2>Inspection and refunds</h2>
      <p>
        We will notify you after an authorized return is received and inspected.
        Approved refunds are sent to the original payment method unless another
        method is required or agreed. Bank processing times can delay when the
        credit appears. Original expedited shipping, duties, and import fees are
        not normally refundable on a change-of-mind return, except where law
        requires otherwise.
      </p>

      <h2>Exchanges</h2>
      <p>
        Exchange availability depends on stock and destination. We may process
        an eligible exchange as a return and a separate purchase so availability,
        payment, and delivery are recorded correctly.
      </p>

      <h2>Refund not received</h2>
      <p>
        First check with your bank or payment provider because posted credits
        can take time. If the expected processing period has passed, email
        <PolicyEmail subject="Refund status" /> with your order number.
      </p>
      <p><strong>Mailing address:</strong> {POLICY_ADDRESS}</p>
    </PolicyPage>
  );
}

export default Returns;
